/**
 * The first send goes to a small slice (Warren, 23 October 2026, item 6:
 * "the first send goes to a small slice, and I approve the size").
 *
 * Every newsletter draft and every campaign run is sent in two steps:
 *
 *   first_slice  the first send names "send to at most N recipients"; a
 *                person types N (Admin's confirm dialog starts empty; the
 *                Mcp's newsletter_send and campaign_send require it). At most
 *                N people are emailed in total under that draft or run, a
 *                retry of a first slice that stopped included. Everyone else
 *                stays pending.
 *   remainder    a PERSON sends the rest, in Admin (an operator or super
 *                admin, never the agent). Everyone the first slice reached is
 *                skipped (the per-campaign send log), and the monthly cap and
 *                one-send-per-address rules hold as always.
 *
 * A first slice that reached everyone (N at least the audience) finishes the
 * send outright: there is no remainder.
 *
 * Shared by the Api (the rule), Admin (the dialog) and the Mcp (the tools),
 * so the three agree on what a valid size is.
 */
export const MARKETING_SEND_PHASES = ['first_slice', 'remainder'];
/** The largest first slice: the per-send ceiling of the campaign engine. */
export const MARKETING_SLICE_MAX = 20_000;
/** The first send named no size (or an invalid one). */
export const SLICE_REQUIRED = 'SLICE_REQUIRED';
/** The first slice went out; the rest waits for a person to send the remainder. */
export const REMAINDER_PENDING = 'REMAINDER_PENDING';
/** Only a person (an operator or super admin in Admin) sends the remainder. */
export const REMAINDER_NEEDS_PERSON = 'REMAINDER_NEEDS_PERSON';
/**
 * A slice size as a whole number from 1 to MARKETING_SLICE_MAX, from a
 * number or a string of digits (what an input field holds), else null.
 * Nothing is rounded or clamped: 2.5, 0, -3, 20001, '', '12abc' are all null,
 * so a typo is refused rather than silently changed.
 */
export function parseSliceSize(raw) {
    let n;
    if (typeof raw === 'number')
        n = raw;
    else if (typeof raw === 'string' && /^\s*\d{1,6}\s*$/.test(raw))
        n = Number(raw.trim());
    else
        return null;
    if (!Number.isInteger(n) || n < 1 || n > MARKETING_SLICE_MAX)
        return null;
    return n;
}
/** The message for a first send that named no valid size. */
export function sliceRequiredMessage() {
    return `The first send of a newsletter or campaign goes to a small slice: name max_recipients, a whole number from 1 to ${MARKETING_SLICE_MAX}. `
        + 'At most that many people are emailed; the rest stay pending until a person sends the remainder in Admin.';
}
//# sourceMappingURL=marketingSlice.js.map